import * as React from 'react';

var _path, _path2;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgDot = function SvgDot(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#FF2670",
        fillRule: "evenodd",
        d: "M60 120C27 120 0 93 0 59.701.3 26.701 27-.298 60.3.002c33 .3 59.7 27 59.7 60.6C119.7 93.3 93 120 60 120",
        clipRule: "evenodd"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M60.592 36.748c7.686 0 13.917-3.696 13.917-8.255s-6.23-8.255-13.917-8.255-13.918 3.696-13.918 8.255 6.231 8.255 13.918 8.255M60.592 98.917c7.686 0 13.917-3.697 13.917-8.256s-6.23-8.255-13.917-8.255-13.918 3.696-13.918 8.255 6.231 8.255 13.918 8.255M41.193 48.162c3.844-6.785 3.82-14.133-.053-16.412s-10.128 1.374-13.971 8.159-3.82 14.133.053 16.411c3.873 2.28 10.128-1.373 13.971-8.158M94.02 79.246c3.843-6.785 3.818-14.133-.055-16.413s-10.13 1.373-13.973 8.158-3.818 14.133.055 16.413 10.13-1.373 13.973-8.158M41.14 87.406c3.874-2.28 3.899-9.628.055-16.413s-10.099-10.437-13.972-8.158c-3.874 2.28-3.899 9.628-.056 16.413s10.1 10.437 13.973 8.158M93.964 56.319c3.873-2.28 3.898-9.628.055-16.413s-10.1-10.437-13.973-8.158-3.899 9.628-.055 16.413S90.09 58.6 93.964 56.32"
    })));
};

export { SvgDot as ReactComponent };
//# sourceMappingURL=DOT.svg.es.js.map
